module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/dropdown.svg
// module id = 106
// module chunks = 0